<form [formGroup]="form" class="eidos-settings-dialog">
  <h1 class="eidos-settings-dialog-title">Settings</h1>

  <div class="eidos-settings-dialog-content">
    <div class="eidos-settings-field">
      <label for="settings-company">Company</label>
      <select id="settings-company" formControlName="company" name="company">
        <option *ngFor="let company of availableCompanies$|async" [value]="company.code">
          {{company.description}}
        </option>
      </select>
    </div>
    <div class="eidos-settings-field" *ngIf="enableOrganization">
      <label for="settings-organization">Organization</label>
      <select id="settings-organization" formControlName="organization" name="organization">
        <option *ngFor="let organization of availableOrganizations$|async" [value]="organization.code">
          {{organization.description}}
        </option>
      </select>
    </div>
    <div *ngIf="eidosSecurityService.isDeveloperUser()"
      class="eidos-settings-dev-options">
      <div>
        Test Production Level
        <input type="checkbox"
          [checked]="eidosSecurityService.testProductionLevel"
          (click)="eidosSecurityService.testProductionLevel = !eidosSecurityService.testProductionLevel" />
      </div>
    </div>
  </div>

  <div class="eidos-settings-dialog-actions">
    <button class="eidos-button eidos-button-normal eidos-button-cancel" type="button" (click)="onCancelClick()">Cancel</button>
    <button class="eidos-button eidos-button-normal eidos-button-success" type="submit" (click)="onSaveClick()"
      [disabled]="form.invalid">Submit</button>
  </div>
</form>
